import { ApiUtility } from "../../Utilities/ApiUtility.axios";

export enum BankAdjustType {
  BankToBank = 2,
  BankToCash = 3,
  CashToBank = 4,
  IncreaseBalance = 5,
  ReduceBalance = 6,
}
export enum BankStatus {
  All,
  Active,
  Delete,
}

export enum ChequeBookStatus {
  All,
  YetToBeUsed,
  Using,
  Used,
  Archived,
}

class ChequeBookServices {
  route = `V1/API/Billing/Acc_ChequeBook`;

  addChequeBook = (
    companyId: string | undefined,
    ledgerId: string,
    data: any,
    chequeBookId?: string | null | undefined
  ) => {
    // Base URL
    let url = `${this.route}/${companyId}/Ledger/${ledgerId}`;
    if (chequeBookId) {
      url += `/${chequeBookId}`;
    }
    return ApiUtility.post(url, data);
  };

  getChequeBooks = (
    companyId: string | undefined,
    ledgerId: string,
    data: any
  ) =>
    ApiUtility.get(
      `${this.route}/${companyId}/Ledger/${ledgerId}/GetList`,
      data
    );

  makeArchive = (companyId: string | undefined, ledgerId: string, data: any) =>
    ApiUtility.get(
      `${this.route}/${companyId}/Ledger/${ledgerId}/MakeArchive`,
      data
    );

  getChequeBook = (companyId: string | undefined, id: string) =>
    ApiUtility.get(`${this.route}/${companyId}/${id}`);
}

export default new ChequeBookServices();
